import api from "utils/api";
import { errHandler } from "utils/common";

export default class LaporanBKK {
  ZeroReportBKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/zero-report-bkk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  BasicDataBKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/data-dasar-bkk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  BasicDataBKKWilker = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/data-dasar-bkk-wilker`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  MicroscopistBKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/microscopists-bkk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  DataDasarLabBKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/data-dasar-lab-bkk-rekap`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Regmal1BKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/laporan-regmal-1-bkk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RegmalRujukanBKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/laporan-regmal-1-rujukan-bkk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
